import { render, staticRenderFns } from "./showIdeaProjectsSchoolsStandPreview.vue?vue&type=template&id=537e0dc6&scoped=true"
import script from "./showIdeaProjectsSchoolsStandPreview.vue?vue&type=script&lang=js"
export * from "./showIdeaProjectsSchoolsStandPreview.vue?vue&type=script&lang=js"
import style0 from "./showIdeaProjectsSchoolsStandPreview.vue?vue&type=style&index=0&id=537e0dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e0dc6",
  null
  
)

export default component.exports